// eslint-disable-next-line import/no-cycle
import { NextStepEnum, TemplateParentTypeEnum, WidgetTypeEnum } from '@/types';
// eslint-disable-next-line import/no-cycle
import { getWidgetStructures } from '../utils/raw-html-templates';

// eslint-disable-next-line import/prefer-default-export
export const getFormWidgetsForNextStep = (nextStep: NextStepEnum, t: Function, isV4 = false) => {
  switch (nextStep) {
    case NextStepEnum.COLLECT_PERSONAL_INFO:
      return [
        {
          formOptions: {
            contactProperty: 'last_name',
            showLabelInside: true,
            fieldRequired: false,
          },
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => getWidgetStructures(
            t,
            {
              customLabel: t('templateBuilder.fields.lastname'),
              customPlaceholder: t('templateBuilder.fields.lastname'),
              contactProperty: 'last_name',
            },
            isV4,
          )[templateType][WidgetTypeEnum.INPUT_TEXT](),
        },
        {
          formOptions: {
            contactProperty: 'first_name',
            showLabelInside: true,
            fieldRequired: false,
          },
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => getWidgetStructures(
            t,
            {
              customLabel: t('templateBuilder.fields.firstname'),
              customPlaceholder: t('templateBuilder.fields.firstname'),
              contactProperty: 'first_name',
            },
            isV4,
          )[templateType][WidgetTypeEnum.INPUT_TEXT](),
        },
        {
          formOptions: {
            contactProperty: 'birthday',
            showLabelInside: true,
            fieldRequired: false,
            dateFormat: 'JJ/MM/YYYY',
          },
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => getWidgetStructures(
            t,
            {
              customLabel: t('templateBuilder.fields.birthday'),
              customPlaceholder: t('templateBuilder.fields.birthday'),
              contactProperty: 'birthday',
            },
            isV4,
          )[templateType][WidgetTypeEnum.INPUT_DATE](),
        },
        {
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => getWidgetStructures(
            t,
            {
              customLabel: t('validate'),
              customHref: '#send-form_close',
            },
            isV4,
          )[templateType][WidgetTypeEnum.BUTTON](),
        },
      ];
    case NextStepEnum.COLLECT_PHONE_NUMBER:
      return [
        {
          formOptions: {
            contactProperty: 'phone',
            showLabelInside: true,
            fieldRequired: false,
          },
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => getWidgetStructures(
            t,
            {
              customLabel: t('templateBuilder.fields.phoneNumber'),
              customPlaceholder: t('templateBuilder.fields.phoneNumber'),
              contactProperty: 'phone',
            },
            isV4,
          )[templateType][WidgetTypeEnum.INPUT_TEXT](),
        },
        {
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => getWidgetStructures(
            t,
            {
              customLabel: t('validate'),
              customHref: '#send-form_close',
            },
            isV4,
          )[templateType][WidgetTypeEnum.BUTTON](),
        },
      ];
    case NextStepEnum.OFFER_VOUCHER:
      return [
        {
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => (getWidgetStructures(
            t,
            {},
            isV4,
          )[templateType][WidgetTypeEnum.TITLE] as (text?: string) => string)('Voici votre code de réduction'),
        },
        {
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => (getWidgetStructures(
            t,
            {},
            isV4,
          )[templateType][WidgetTypeEnum.TEXT] as (text?: string) => string)('<p>{var=voucher.amount} de réduction valable jusqu\'au {var=voucher.date_end}.<br>Pour découvrir votre code, veuillez cliquer sur le bouton ci-dessous.</p>'),
        },
        {
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => getWidgetStructures(
            t,
            {},
            isV4,
          )[templateType][WidgetTypeEnum.VOUCHER](),
        },
        {
          getWidgetHtml: (templateType: TemplateParentTypeEnum) => {
            const html = (getWidgetStructures(
              t,
              {},
              isV4,
            )[templateType][WidgetTypeEnum.TEXT] as (text?: string) => string)('<p>Le montant minimum d\'achat pour bénéficier de cette offre est de {var=voucher.minimum_order}.</p>');
            const sSegments = '[[{"id":"voucher_minimum_order","groupProperty":"voucher","operator":"number_greater_than","data":0,"context":"voucher.minimum_order"}]]';
            return html.replace(/^<div /, `<div s-segments='${sSegments}' `);
          },
        },
      ];
    default:
      return [];
  }
};
